import { SendAnalytics, GenerateLabel } from "../main";

const analytics = SendAnalytics('analysis')

/** 👇 view analysis */
const ViewAnalysis = () => analytics({
  label: GenerateLabel({}),
  action: 'analysis - view analysis',
  name: 'view_analysis',
});

/** 👇 users click category,
 * category = saham/hot list/day briefing/morning briefing
 */
const ClickCategoryAnalysis = ({ category = '' }) => analytics({
  label: GenerateLabel({ category }),
  action: 'analysis - click category',
  name: 'click_category_analysis',
});

/** 👇 users click search */
const ClickSearchAnalysis = () => analytics({
  label: GenerateLabel({}),
  action: 'analysis - click search',
  name: 'click_search_analysis',
});

/** 👇 users search enter */
const EnterSearchAnalysis = () => analytics({
  label: GenerateLabel({}),
  action: 'analysis - search enter',
  name: 'enter_search_analysis',
});

/** 👇 users click filter */
const ClickFilterAnalysis = () => analytics({
  label: GenerateLabel({}),
  action: 'analysis - click filter',
  name: 'view_aclick_filter_analysis',
});

/** 👇 users click filter ok,
 * posted = today/yesterday/last 7 days/last 14 days/last 30 days
 */
const FilterAnalysis = ({
  posted = '',
  type = 'video, artikel',
}) => analytics({
  label: GenerateLabel({ type, posted }),
  action: 'analysis - click filter ok',
  name: 'filter_analysis',
});

/** 👇 users click chart */
const ClickChart = () => analytics({
  label: GenerateLabel({}),
  action: 'analysis - click chart',
  name: 'click_chart',
});

/** 👇 users click content,
 * category = saham/hot list/day briefing/morning briefing
 */
const ClickContentAnalysis = ({
  contentTitle = '',
  category = '',
  contentType = 'video, artikel',
}) => analytics({
  label: GenerateLabel({ category, contentType, contentTitle }),
  action: 'analysis - click content',
  name: 'click_content_analysis',
});

const Analysis = {
  ViewAnalysis,
  ClickCategoryAnalysis,
  ClickSearchAnalysis,
  EnterSearchAnalysis,
  ClickFilterAnalysis,
  FilterAnalysis,
  ClickChart,
  ClickContentAnalysis,
};

export default Analysis;
